import { useState } from "react";
import { accentFor, type StoreListing } from "@/api/store.api";
import { cn } from "@/lib/utils";

type ListingIconProps = {
  listing: Pick<StoreListing, "packageName" | "name" | "iconUrl">;
  size: number;
  className?: string;
  /** Corner radius as a fraction of size; the phone app uses 0.28. */
  radius?: number;
};

/** The listing's icon, or an accent tile with its initial while there is none (or it fails). */
export function ListingIcon({ listing, size, className, radius: radiusRatio = 0.24 }: ListingIconProps) {
  const [failed, setFailed] = useState(false);
  const radius = Math.round(size * radiusRatio);
  if (listing.iconUrl && !failed) {
    return (
      <img
        src={listing.iconUrl}
        alt=""
        width={size}
        height={size}
        loading="lazy"
        onError={() => setFailed(true)}
        className={cn("shrink-0 bg-white object-cover", className)}
        style={{ width: size, height: size, borderRadius: radius }}
      />
    );
  }
  return (
    <div
      aria-hidden
      className={cn("flex shrink-0 items-center justify-center font-display font-bold text-white", className)}
      style={{ width: size, height: size, borderRadius: radius, backgroundColor: accentFor(listing.packageName), fontSize: size * 0.42 }}
    >
      {listing.name.trim().charAt(0).toUpperCase() || "?"}
    </div>
  );
}
